import { useSelector } from "react-redux";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppState } from "../definitions";
import { z } from "zod";

export const ZodFaq = z.object({
  key: z.string(),
  data: z.object({
    key: z.string(),
    question: z.string(),
    answer: z.string(),
    link: z.string().optional(),
  }),
});

export type Faq = z.infer<typeof ZodFaq>;

export type FaqState = {
  faqs: Faq[];
};

const initialState: FaqState = {
  faqs: [],
};

export const faqSlice = createSlice({
  name: "faq",
  initialState,
  reducers: {
    setFaqs: (state, action: PayloadAction<FaqState>) => {
      state.faqs = action.payload.faqs;
    },
  },
});

export const { setFaqs } = faqSlice.actions;
export const faqReducer = faqSlice.reducer;

export const useFaqs = () => useSelector((state: AppState) => state.faq.faqs);
